RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.Overview = window.createMarionetteApp();
    app.name = 'Overview';


    app.getPanelToolbar = function (exportPanelId, channel, section, slideName, additionalItems, exportOptions) {
        exportOptions = exportOptions || {};
        const reportType = RivalIQ.apps.Reports.enums.reportTypes.BARE;
        let items = [
            {
                type: RivalIQ.export.type.DOWNLOAD,
                format: RivalIQ.export.format.PNG,
                parameters: {
                    exportPanelId: exportPanelId
                }
            },
            {
                type: RivalIQ.export.type.DOWNLOAD,
                format: RivalIQ.export.format.PDF,
                parameters: {
                    exportPanelId: exportPanelId
                }
            },
            {
                type: RivalIQ.export.type.DOWNLOAD,
                format: RivalIQ.export.format.PPT,
                parameters: {
                    reportType: reportType,
                    exportPanelId: exportPanelId,
                    slideName: slideName
                }
            }
        ];

        if (additionalItems) {
            items = items.concat(additionalItems);
        }

        const panelToolbar = {
            export: _.extend({
                id: exportPanelId,
                title: slideName,
                tracking: RivalIQ.tracking.metric.V3UsedExportInOverview,
                btnClass: 'btn-xs',
                parameters: {
                    renderLimit: Number.MAX_VALUE,
                    channel: channel,
                    section: section
                },
                items: items
            }, exportOptions)
        };

        return panelToolbar;
    };

});
